import { get, flow } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getSearch = get('outreach.components.search');

export const getByContext = createSelector(getSearch, get('byContext'));

export const getContextFor = createSelector(
  (_, context) => context,
  getByContext,
  get
);

export const getSearchQueryForContext = flow(
  getContextFor,
  get('query')
);
